import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViaCep } from '@app-model/application';
import { City } from '@app-model/city';
import { ApplicationService } from '@app-services/application.service';
import { OpenService } from '@app-services/open.service';
import { DealerDetails, MaritalStatus } from '@app/views/private/admin/model/admin-models';
import { AdminService } from '@app/views/private/admin/services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dialog-personal-info',
  templateUrl: './dialog-personal-info.component.html',
  styleUrls: ['./dialog-personal-info.component.scss']
})
export class DialogPersonalInfoComponent implements OnInit {

  dealer : DealerDetails;

  phoneNumber;
  selectedCity: City;
  cityOptions: Observable<City[]>;

  constructor(
    private dialogRef: MatDialogRef<DialogPersonalInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toaster: ToastrService,
    private applicationService: ApplicationService,
    private openService: OpenService,
    private adminService: AdminService
  ) { 
    this.dealer = data.dealer;
  }

  ngOnInit() {
  }

  get maritalStatuses(): string[] {
    return Object.keys(MaritalStatus);
  }

  getMaritalStatus(status): string {
    return MaritalStatus[status];
  }

  addPhone() {
    if (this.phoneNumber.indexOf("_") < 0 && this.phoneNumber != "") {
      this.dealer.phoneNumbers.push(this.phoneNumber);

      this.phoneNumber = "";
    } else {
      this.toaster.error("Telefone inválido");
    }
  }

  getCEP() {
    var cep = this.dealer.zipCode;
    let viaCep: ViaCep;
    if (
      cep === undefined ||
      cep.trim() === "" ||
      cep.trim().replace("-", "").length < 8
    ) {
      return;
    }

    this.applicationService
      .getCep(cep.trim().replace("-", ""))
      .subscribe((response: ViaCep) => {
        // update form
        this.dealer.address = response.logradouro;
        this.dealer.district = response.bairro


        this.openService.searchCitiesByName(response.localidade).subscribe(cityOptions => {
          const city = cityOptions.find(c => c.name === response.localidade && c.uf === response.uf);
          if (city) {
            this.selectCity(city);
          }
        });
      });
  }

  selectCity(city: City) {
    this.dealer.cityName = city.name + " - " + city.uf;
    this.selectedCity = city;
  }
  
  removePhone(phoneIndex: number): void {
    this.dealer.phoneNumbers.splice(phoneIndex, 1);
  }

  saveDealer() {
    if(!this.dealer.name || this.dealer.name == ""){
      this.toaster.error("Campo NOME FANTASIA inválido")
      return;
    }

    if(!this.dealer.zipCode || this.dealer.zipCode == ""){
      this.toaster.error("Campo CEP inválido")
      return;
    }

    if(!this.dealer.address || this.dealer.address == ""){
      this.toaster.error("Campo ENDEREÇO inválido")
      return;
    }

    if(!this.dealer.addressNumber || this.dealer.addressNumber == ""){
      this.toaster.error("Campo NÚMERO inválido");
      return;
    }

    if(!this.dealer.district || this.dealer.district == ""){
      this.toaster.error("Campo BAIRRO inválido");
      return;
    }

    if(!this.dealer.cityName || this.dealer.cityName == ""){
      this.toaster.error("Campo CIDADE inválido")
      return;
    }

    if(!this.dealer.maritalStatus || this.dealer.maritalStatus == ""){
      this.toaster.error("Campo ESTADO CÍVIL inválido");
      return;
    }

    if(!this.dealer.district || this.dealer.district == ""){
      this.toaster.error("Campo BAIRRO inválido");
      return;
    }
    if(this.selectedCity){
      this.dealer.cityId = this.selectedCity.id;
      this.dealer.cityName = this.selectedCity.name;
      this.dealer.uf = this.selectedCity.uf;
    }
    this.adminService.saveDealer(this.dealer).subscribe(resp => {
      if (resp.success) {
        this.toaster.success("salvo com sucesso.");
        this.dialogRef.close({ success : true});
      } else {
        this.toaster.error(resp.message);
      this.dialogRef.close({ success : false});
      }

    })
  }
}
